import { render, staticRenderFns } from "./ColorPickerSketch.vue?vue&type=template&id=2a51ae4e&"
import script from "./ColorPickerSketch.vue?vue&type=script&lang=js&"
export * from "./ColorPickerSketch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports